import { render, staticRenderFns } from "./SignalTokenPrice.vue?vue&type=template&id=02138e12&scoped=true&"
import script from "./SignalTokenPrice.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SignalTokenPrice.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02138e12",
  null
  
)

export default component.exports